<template>
  <header id="header">

    <nav class="navbar navbar-expand-sm navbar-dark bg-dark stihl-navbar">

      <div class="container-md">

        <div class="btn-close-window" v-if="isWindowClosable">
          <a class="navbar-brand nav-link" href="#">
            <i class="bi bi-backspace centered" style="font-size: 2rem" role="img"
               :title="$t('dss.button.back')"
               @click="closeWindow"></i>
          </a>
        </div>


        <a class="navbar-brand" href="#">
          <img id="logo" src="../../assets/img/logo.svg" alt="STIHL - Dealer Self-Service">
          <span id="app-name" class="d-none d-sm-inline">{{ $t('dss.name') }}</span>
        </a>

        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target=".multi-collapse"
                aria-controls="navbarContent navMenu" aria-expanded="false" aria-label="Toggle navigation"
                v-if="isUserLoggedIn">
          <i class="navbar-toggler-icon"></i>
        </button>

        <div id="navbarContent" class="collapse multi-collapse navbar-collapse justify-content-end" v-if="isUserLoggedIn">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item ml-auto">
              <button id="logout-link" type="submit" class="btn nav-link p-3" @click="logout">
                {{ $t('dss.button.logout') }}
              </button>
            </li>
          </ul>

        </div>

      </div>
    </nav>
  </header>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {userManager} from '@/components/oidc.js'
import {User} from "oidc-client-ts";

export default defineComponent({
  name: "StihlHeader",
  data() {
    return {
      isUserLoggedIn: false,
      isWindowClosable: window.opener !== null,
    }
  },
  methods: {
    updateUserStatus(user: User | null) {
      if (user) {
        this.isUserLoggedIn = true
        console.debug('[StihlHeader] user logged-in', user.profile)
      } else {
        console.debug("[StihlHeader] no user data")
      }
    },
    logout() {
      window.location.href = `/auth/stihl/sign-out.jsp?goto=${new URL(window.location.href).origin}/user/ui/`;
      /// Important!
      /// OIDC logout - kills the session that generated the token,
      /// but an add passkey or add TOTP will generate a new session
      //userManager.signoutRedirect()
      return false
    },
    closeWindow() {
      window.close()
    }
  },
  mounted() {
    userManager.events.addUserLoaded(this.updateUserStatus) // register for addUserLoaded event
    userManager.getUser().then(this.updateUserStatus)
  },
})
</script>

<style scoped>
.bi::before, [class^="bi-"]::before, [class*=" bi-"]::before {
  vertical-align: middle;
}
</style>
